module.exports = __webpack_public_path__ + "assets/80e97b3154a06c37dc0d8e028415c6e2.mp3";